import React from 'react';
import { portfolioData } from '../data/portfolioData';

const Resume = () => (
  <div className="resume-page">    
    <div className="resume-content">

      <h1>Relevant Work Experience</h1>
      
      <div className="experience-section">
        {portfolioData.resume.experience.map((exp, index) => (
          <div key={index} className="experience-item">
            <h3>{exp.company}</h3>
            <div className="experience-columns">
              <div className="experience-roles">
                {exp.roles.map((role, index) => (
                <div className="experience-role" key={index}>
                  <h4 className="role">{role.title}</h4>
                  <span className="period">{role.period}</span>
                </div>
                ))}
              </div>
              <ul>
                {exp.description.map((desc, index) => (
                  <li className="description" key={index}>{desc}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>

      <hr></hr>
      
      <div className="additional-sections">
        <div className="section">
          <h1>Education</h1>
          <h3>{portfolioData.resume.education.school}</h3>
          <h4 className="role">{portfolioData.resume.education.earned}</h4>
          <span className="period">{portfolioData.resume.education.period}</span>
        </div>
        
        <div className="section">
          <h1>Software & Skills</h1>
          <p>{portfolioData.resume.skills.proficient}</p>
          <p><span className="subtitle">Interest and some experience</span><br />{portfolioData.resume.skills.interested}</p>
        </div>
      </div>
    </div>
  </div>
);

export default Resume;